<template>
    <el-dialog v-dialogDrag  class="dialog" width="800px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑费用
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="费用代码">
                    <el-input v-model="form.feeCode" placeholder="请输入费用代码"></el-input>
                </el-form-item>
                <el-form-item label="费用名称" prop="feeName">
                    <el-input v-model="form.feeName" placeholder="请输入费用名称"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.feeType" placeholder="请选择类型" style="width: 200px">
                        <el-option label="制造费用" value="制造费用"></el-option>
                        <el-option label="销售费用" value="销售费用"></el-option>
                        <el-option label="管理费用" value="管理费用"></el-option>
                        <el-option label="财务费用" value="财务费用"></el-option>
                        <el-option label="税金及附加" value="税金及附加"></el-option>
                        <el-option label="所得税费用" value="所得税费用"></el-option>
                        <el-option label="利润分配" value="利润分配"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        data() {
            return {

                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        methods: {

            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if(this.form.feeName==null){
                    this.$message({message: '请输入费用名称', type: 'error'});
                    return false;
                }
                if(this.form.feeCode==null){
                    this.$message({message: '请输入费用代码', type: 'error'});
                    return false;
                }
                if(this.form.feeType==null){
                    this.$message({message: '请输入费用类型', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
        }
    }
</script>